import { ButtonContainer, ButtonText } from './ButtonWithIcon.styles'
import React from 'react'

export type ButtonWithIconProps = {
    onClick: () => void
    icon: React.ReactNode
    text: string
    containerStyle?: React.CSSProperties
    disabled?: boolean
}

const ButtonWithIcon = ({
    onClick,
    icon,
    text,
    containerStyle,
    disabled = false
}: ButtonWithIconProps) => {
    return (
        <ButtonContainer
            type="button"
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            style={{
                ...containerStyle,
                opacity: disabled ? 0.6 : 1,
                cursor: disabled ? 'not-allowed' : 'pointer'
            }}
        >
            {icon}
            <ButtonText>{text}</ButtonText>
        </ButtonContainer>
    )
}

export default ButtonWithIcon
